import { makeStyles, Grid } from "@material-ui/core";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
} from "App/constants";
import { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
} from "App/Component/ui";
import { useSelectOption } from "App/hooks";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { urlCreateBarang, urlUpdateBarang } from "../../helpers";
import moment from "moment";

export const RESET_STATE_PEMBELIAN_BARANG = {
  pembelian_id: "",
  barang_id: "",
  name: "",

  satuan_id: "",
  namasatuan: "Pilih Satuan",

  satuanjual_id: "",
  harga: "",
  harga2: "",
  qty: 1,
  disc: 0,
  nilai_disc: 0,
  qjb: 0,
  hargaqjbhpp: 0,
  nobatch: "",
  exired_date: "",
  is_proses: true,
  is_po_proses: false,
  remark: "-",

  // PO
  po_satuan_id: "",
  po_qty: "",
  po_harga_satuan: "",
  po_disc: "",
  po_nilai_disc: "",
};

export const STYLE_WMS_PO = makeStyles({
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "satuan",
    disablePadding: false,
    label: "SATUAN BELI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "qjb",
    disablePadding: false,
    label: "QJB",
    align: "left",
  },
  {
    id: "harga",
    disablePadding: false,
    label: "HARGA BELI",
    align: "left",
    minWidth: "150px",
  },
];

export const ModalBarang = ({
  setShowModal,
  formBarang,
  setFormBarang,
  setNewDataPembelianList,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const satuan = useSelectOption(
    false,
    "/wmsMasterAsset/satuan/list",
    TYPE_INSTANCE4
  );

  const { formData } = useContext(FormContext);

  const handleChange = (text) => (e) => {
    setFormBarang({
      ...formBarang,
      [text]: e.target.value,
    });
  };

  const create = async () => {
    if (isNull(formBarang.satuan_id)) {
      defaultToastError("Gagal - Harap lengkapi data barang");
    } else {
      const api = await instance4.post(urlCreateBarang, {
        pembelian_id: formData.id,
        nama_barang: formBarang.name,
        satuan_id: formBarang.satuan_id,
        harga_satuan: convertToValidPrice(formBarang.harga2),
        qty: parseInt(formBarang.qty),
        disc: parseFloat(convertToValidPrice(formBarang.disc)),
        nilai_disc: parseFloat(convertToValidPrice(formBarang.nilai_disc)),
        qjb: formBarang.qjb,
        hargaqjbhpp: convertToValidPrice(formBarang.hargaqjbhpp),
        nobatch: formBarang.nobatch,
        exired_date: moment(formBarang.exired_date).format(),
        remark: "-",
      });
      return api;
    }
  };

  const update = async () => {
    if (isNull(formBarang.satuan_id)) {
      defaultToastError("Gagal - Harap lengkapi data barang");
    } else {
      const api = await instance4.post(urlUpdateBarang, {
        id: formBarang.id,
        pembelian_id: formData.id,
        nama_barang: formBarang.name,
        satuan_id: formBarang.satuan_id,
        harga_satuan: convertToValidPrice(formBarang.harga2),
        qty: convertToValidPrice(formBarang.qty),
        disc: parseFloat(convertToValidPrice(formBarang.disc)),
        nilai_disc: parseFloat(convertToValidPrice(formBarang.nilai_disc)),
        qjb: formBarang.qjb,
        hargaqjbhpp: convertToValidPrice(formBarang.hargaqjbhpp),
        nobatch: formBarang.nobatch,
        exired_date: moment(formBarang.exired_date).format(),
        remark: "-",
      });
      return api;
    }
  };

  // useEffect(() => {
  //   setFormBarang({
  //     ...formBarang,
  //     harga: convertToValidPrice(formBarang.harga2),
  //   });
  // }, [formBarang.harga2]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (isNull(formBarang.name)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama barang tidak boleh kosong");
    } else {
      if (parseInt(formBarang.qty) <= 0 || isNull(formBarang.qty)) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError("Banyak barang tidak boleh kosong");
      } else {
        if (formBarang.harga2 <= 0 || isNull(formBarang.harga2)) {
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          defaultToastError("Harga barang tidak boleh kosong");
        } else {
          try {
            if (formBarang.id === "") {
              // if (isNull(formData.po_id)) {
              const res = await create();
              if (res.data.status === 200) {
                succesCreateOrUpdate("Menambah");
                setNewDataPembelianList(formData.id);
              } else {
                setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                defaultToastError(res.data.message);
              }
              // } else {
              //   defaultToastError("Jika ada po tidak bisa menambah barang!");
              // }
            } else {
              const res = await update();
              if (res.data.status === 200) {
                setNewDataPembelianList(formData.id);
                succesCreateOrUpdate("Mengupdate");
              } else {
                setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
                defaultToastError(res.data.message);
              }
            }
          } catch (error) {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(error?.response?.data?.message);
          }
        }
      }
    }
  };

  const succesCreateOrUpdate = (label) => {
    defaultToastSuccess(`Berhasil ${label} Barang`);
    setNewDataPembelianList();
    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    setShowModal(false);
  };

  return (
    <Modal title={`REALISASI PEMBELIAN BARANG`} show={setShowModal} width="60%">
      {formData.id === "" ? (
        <p className="mt-2 mb-2 text-center">
          Silahkan buka transaksi terlebih dahulu
        </p>
      ) : (
        <form action="POST" onSubmit={(e) => handleSubmit(e)}>
          <p className="mb-1">{formBarang.name}</p>

          {/* <div>
            <div
              style={{
                background: "#EAEAEA",
                marginLeft: "-30px",
                marginRight: "-20px",
              }}
            >
              <h5
                style={{
                  padding: "0.5rem 2rem",
                  color: "#828282",
                }}
              >
                DATA PO
              </h5>
            </div>
            <div className="mt-1">
              <Grid container spacing={1}>
                <InputTextMaster
                  type="hidden"
                  name="barang_id"
                  id="barang_id"
                  readOnly={true}
                  value={formBarang?.barang_id}
                />
                <Grid item sm={3}>
                  {formData.is_po ? (
                    <InputOptionMaster
                      name="po_satuan_id"
                      label="SATUAN"
                      id="po_satuan_id"
                      withSearch={true}
                      data={satuan}
                      labelValue={formBarang.namasatuan}
                      value={formBarang.satuan_id}
                      onChange={(e) => {
                        if (isNull(e)) {
                          setFormBarang({
                            ...formBarang,
                            satuan_id: null,
                            namasatuan: "Pilih Satuan",
                          });
                        } else {
                          setFormBarang({
                            ...formBarang,
                            satuan_id: e.value,
                            namasatuan: e.label,
                          });
                        }
                      }}
                      disabled={true}
                      readOnly={true}
                    />
                  ) : (
                    <InputTextMaster
                      type="text"
                      name="satuan_id"
                      id="satuan_id"
                      value={"-"}
                      label={"SATUAN"}
                      readOnly={true}
                      disabled={true}
                    />
                  )}
                </Grid>
                <Grid item sm={2}>
                  {formData.is_po ? (
                    <InputTextMaster
                      name="po_qty"
                      label="BANYAK"
                      id="po_qty"
                      value={formBarang.qty}
                      onChange={(e) => {
                        let val = e.target.value;
                        if (!isNull(val)) {
                          setFormBarang({
                            ...formBarang,
                            qty: formatRupiah(val),
                            nilai_disc: formatNumber(
                              (convertToValidPrice(formBarang.disc) / 100) *
                                (convertToValidPrice(formBarang.harga2) * parseFloat(val))),
                          });
                        } else {
                          setFormBarang({
                            ...formBarang,
                            qty: val,
                          });
                        }
                      }}
                      disabled={true}
                      readOnly={true}
                      placeholder="Banyak"
                    />
                  ) : (
                    <InputTextMaster
                      name="qty"
                      label="BANYAK"
                      id="qty"
                      value="-"
                      disabled={true}
                      readOnly={true}
                      placeholder="Banyak"
                    />
                  )}
                </Grid>

                <Grid item sm={2}>
                  {formData.is_po ? (
                    <InputTextMaster
                      name="po_harga_satuan"
                      label="HARGA"
                      id="po_harga_satuan"
                      placeholder="0"
                      value={formBarang.harga2}
                      onInput={(e) => {
                        let val = e.target.value;

                        setFormBarang({
                          ...formBarang,
                          harga2: formatRupiah(val),
                          hargaqjbhpp:
                            convertToValidPrice(val) / formBarang.qjb,
                            nilai_disc: formatNumber(
                              (convertToValidPrice(formBarang.disc) / 100) *
                                (convertToValidPrice(val) * parseFloat(formBarang.qty)),
                            ),
                        });
                      }}
                      disabled={true}
                      readOnly={true}
                      withButtonLeft={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderLeft: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderRight: "0",
                          background: "#f7f7f7",
                          padding: "0 0 0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "6px 0 0 6px",
                          fontSize: "10px",
                        }}
                      >
                        Rp.
                      </button>
                    </InputTextMaster>
                  ) : (
                    <InputTextMaster
                      name="harga"
                      label="HARGA"
                      id="harga"
                      value="-"
                      readOnly={true}
                      disabled={true}
                      withButtonLeft={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderLeft: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderRight: "0",
                          background: "#f7f7f7",
                          padding: "0 0 0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "6px 0 0 6px",
                          fontSize: "10px",
                        }}
                      >
                        Rp.
                      </button>
                    </InputTextMaster>
                  )}
                </Grid>

                <Grid item sm={2}>
                  {formData.is_po ? (
                    <InputTextMaster
                      name="po_disc"
                      label="DISC (%)"
                      id="po_disc"
                      value={formBarang.disc}
                      onChange={(e) => {
                        let val = e.target.value;
                        // if (onlyNumberAndComma(val)) {
                        if (!isNull(formBarang.harga2) && !isNull(val)) {
                          setFormBarang({
                            ...formBarang,
                            disc: formatRupiah(val),
                            nilai_disc: formatNumber(
                              (convertToValidPrice(val) / 100) *
                                (convertToValidPrice(formBarang.harga2) * parseFloat(formBarang.qty))
                            ),
                          });
                        } else {
                          setFormBarang({
                            ...formBarang,
                            disc: val,
                            nilai_disc: 0,
                          });
                        }
                        // }
                      }}
                      placeholder="%"
                      disabled={true}
                      readOnly={true}
                      withButton={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderRight: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderLeft: "0",
                          background: "#f7f7f7",
                          padding: "0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "0 6px 6px 0",
                        }}
                      >
                        %
                      </button>
                    </InputTextMaster>
                  ) : (
                    <InputTextMaster
                      name="disc"
                      label="DISC (%)"
                      id="disc"
                      disabled={true}
                      readOnly={true}
                      value="-"
                      withButton={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderRight: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderLeft: "0",
                          background: "#f7f7f7",
                          padding: "0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "0 6px 6px 0",
                        }}
                      >
                        %
                      </button>
                    </InputTextMaster>
                  )}
                </Grid>

                <Grid item sm={3}>
                  {formData.is_po ? (
                    <InputTextMaster
                      name="po_nilai_disc"
                      label="NILAI DISC"
                      id="po_nilai_disc"
                      value={formBarang.nilai_disc}
                      placeholder="0"
                      disabled={true}
                      readOnly={true}
                      withButtonLeft={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderLeft: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderRight: "0",
                          background: "#f7f7f7",
                          padding: "0 0 0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "6px 0 0 6px",
                          fontSize: "10px",
                        }}
                      >
                        Rp.
                      </button>
                    </InputTextMaster>
                  ) : (
                    <InputTextMaster
                      name="nilai_disc"
                      label="NILAI DISC"
                      id="nilai_disc"
                      disabled={true}
                      readOnly={true}
                      value="-"
                      withButtonLeft={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderLeft: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderRight: "0",
                          background: "#f7f7f7",
                          padding: "0 0 0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "6px 0 0 6px",
                          fontSize: "10px",
                        }}
                      >
                        Rp.
                      </button>
                    </InputTextMaster>
                  )}
                </Grid>
              </Grid>
            </div>
          </div> */}

          <div
            style={{
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                background: "#EAEAEA",
                marginLeft: "-30px",
                marginRight: "-20px",
              }}
            >
              <h5
                style={{
                  padding: "0.5rem 2rem",
                  color: "#828282",
                }}
              >
                DATA PEMBELIAN
              </h5>
            </div>

            <div className="mt-1">
              <Grid container spacing={1}>
                <InputTextMaster
                  type="hidden"
                  name="barang_id"
                  id="barang_id"
                  readOnly={true}
                  value={formBarang.barang_id}
                />
                <Grid item sm={12}>
                  {/* {formData.is_po ? (
                    <InputTextMaster
                      name="namaBarang"
                      label="NAMA BARANG"
                      id="namaBarang"
                      value="-"
                      readOnly={true}
                      disabled={true}
                    />
                  ) : ( */}
                    <InputTextMaster
                      name="namaBarang"
                      label="NAMA BARANG"
                      id="namaBarang"
                      placeholder="Nama Barang"
                      value={formBarang.name}
                      onChange={handleChange("name")}
                    />
                  {/* )} */}
                </Grid>
                <Grid item sm={3}>
                  {/* {formData.is_po ? (
                    <InputTextMaster
                      type="text"
                      name="satuan_id"
                      id="satuan_id"
                      value={"-"}
                      label={"SATUAN"}
                      readOnly={true}
                      disabled={true}
                    />
                  ) : ( */}
                    <InputOptionMaster
                      name="satuan_id"
                      label="SATUAN"
                      id="satuan_id"
                      withSearch={true}
                      data={satuan}
                      labelValue={formBarang.namasatuan}
                      value={formBarang.satuan_id}
                      onChange={(e) => {
                        if (isNull(e)) {
                          setFormBarang({
                            ...formBarang,
                            satuan_id: null,
                            namasatuan: "Pilih Satuan",
                          });
                        } else {
                          setFormBarang({
                            ...formBarang,
                            satuan_id: e.value,
                            namasatuan: e.label,
                          });
                        }
                      }}
                    />
                  {/* )} */}
                </Grid>
                <Grid item sm={2}>
                  {/* {formData.is_po ? (
                    <InputTextMaster
                      name="qty"
                      label="BANYAK"
                      id="qty"
                      value="-"
                      readOnly={true}
                      disabled={true}
                    />
                  ) : ( */}
                    <InputTextMaster
                      name="qty"
                      label="BANYAK"
                      id="qty"
                      value={formBarang.qty}
                      onChange={(e) => {
                        let val = e.target.value;
                        if (!isNull(val)) {
                          setFormBarang({
                            ...formBarang,
                            qty: formatRupiah(val),
                            nilai_disc: formatNumber(
                              (convertToValidPrice(formBarang.disc) / 100) *
                                (convertToValidPrice(formBarang.harga2) * parseFloat(val))),
                          });
                        } else {
                          setFormBarang({
                            ...formBarang,
                            qty: val,
                          });
                        }
                      }}
                      placeholder="Banyak"
                    />
                  {/* )} */}
                </Grid>

                <Grid item sm={2}>
                  {/* {formData.is_po ? (
                    <InputTextMaster
                      name="harga"
                      label="HARGA"
                      id="harga"
                      value="-"
                      readOnly={true}
                      disabled={true}
                      withButtonLeft={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderLeft: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderRight: "0",
                          background: "#f7f7f7",
                          padding: "0 0 0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "6px 0 0 6px",
                          fontSize: "10px",
                        }}
                      >
                        Rp.
                      </button>
                    </InputTextMaster>
                  ) : ( */}
                    <InputTextMaster
                      name="harga"
                      label="HARGA"
                      id="harga"
                      placeholder="0"
                      value={formBarang.harga2}
                      onInput={(e) => {
                        let val = e.target.value;

                        setFormBarang({
                          ...formBarang,
                          harga2: formatRupiah(val),
                          hargaqjbhpp:
                            convertToValidPrice(val) / formBarang.qjb,
                            nilai_disc: formatNumber(
                              (convertToValidPrice(formBarang.disc) / 100) *
                                (convertToValidPrice(val) * parseFloat(formBarang.qty)),
                            ),
                        });
                      }}
                      withButtonLeft={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderLeft: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderRight: "0",
                          background: "#fff",
                          padding: "0 0 0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "6px 0 0 6px",
                          fontSize: "10px",
                        }}
                      >
                        Rp.
                      </button>
                    </InputTextMaster>
                  {/* )} */}
                </Grid>

                <Grid item sm={2}>
                  {/* {formData.is_po ? (
                    <InputTextMaster
                      name="disc"
                      label="DISC (%)"
                      id="disc"
                      value="-"
                      readOnly={true}
                      disabled={true}
                      withButton={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderRight: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderLeft: "0",
                          background: "#f7f7f7",
                          padding: "0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "0 6px 6px 0",
                        }}
                      >
                        %
                      </button>
                    </InputTextMaster>
                  ) : ( */}
                    <InputTextMaster
                      name="disc"
                      label="DISC (%)"
                      id="disc"
                      pattern="[0-9 _,]*"
                      value={formBarang.disc}
                      onChange={(e) => {
                        let val = e.target.value;
                        // if (onlyNumberAndComma(val)) {
                        if (!isNull(formBarang.harga2) && !isNull(val)) {
                          setFormBarang({
                            ...formBarang,
                            disc: formatRupiah(val),
                            nilai_disc: formatNumber(
                              (convertToValidPrice(val) / 100) *
                                (convertToValidPrice(formBarang.harga2) * parseFloat(formBarang.qty))
                            ),
                          });
                        } else {
                          setFormBarang({
                            ...formBarang,
                            disc: val,
                            nilai_disc: 0,
                          });
                        }
                        // }
                      }}
                      placeholder="%"
                      withButton={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderRight: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderLeft: "0",
                          background: "#fff",
                          padding: "0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "0 6px 6px 0",
                        }}
                      >
                        %
                      </button>
                    </InputTextMaster>
                  {/* )} */}
                </Grid>

                <Grid item sm={3}>
                  {/* {formData.is_po ? (
                    <InputTextMaster
                      name="nilai_disc"
                      label="NILAI DISC"
                      id="nilai_disc"
                      value="-"
                      readOnly={true}
                      disabled={true}
                      withButtonLeft={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderLeft: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderRight: "0",
                          background: "#f7f7f7",
                          padding: "0 0 0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "6px 0 0 6px",
                          fontSize: "10px",
                        }}
                      >
                        Rp.
                      </button>
                    </InputTextMaster>
                  ) : ( */}
                    <InputTextMaster
                      name="nilai_disc"
                      label="NILAI DISC"
                      id="nilai_disc"
                      value={formBarang.nilai_disc}
                      readOnly={true}
                      disabled={true}
                      placeholder="0"
                      withButtonLeft={true}
                    >
                      <button
                        type={"button"}
                        onClick={null}
                        style={{
                          borderLeft: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderRight: "0",
                          background: "#f7f7f7",
                          padding: "0 0 0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "6px 0 0 6px",
                          fontSize: "10px",
                        }}
                      >
                        Rp.
                      </button>
                    </InputTextMaster>
                  {/* )} */}
                </Grid>

                {/* <Grid item sm={3}>
                  <InputOptionMaster
                    name="satuanjual_id"
                    label="SATUAN"
                    id="satuanjual_id"
                    withSearch={false}
                    data={satuan}
                    value={formBarang.satuanjual_id}
                    disabled={true}
                    readOnly={true}
                  />
                </Grid> */}
                {/* <Grid item sm={3}>
                  <InputTextMaster
                    name="qjb"
                    label="QJB"
                    id="qjb"
                    value={formBarang.qjb}
                    type="number"
                    onChange={(e) => {
                      let val = e.target.value;
                      if (!isNull(formBarang.harga2) && !isNull(val)) {
                        setFormBarang({
                          ...formBarang,
                          qjb: val,
                          hargaqjbhpp: formatNumber(
                            convertToValidPrice(formBarang.harga2) / val
                          ),
                        });
                      } else {
                        setFormBarang({
                          ...formBarang,
                          qjb: val,
                          hargaqjbhpp: 0,
                        });
                      }
                    }}
                    placeholder="Qjb"
                  />
                </Grid> */}

                {/* <Grid item sm={3}>
                  <InputTextMaster
                    name="nobatch"
                    label="NO BATCH"
                    id="nobatch"
                    value={formBarang.nobatch}
                    onChange={handleChange("nobatch")}
                    placeholder="No. Batch"
                  />
                </Grid> */}
                {/* 
                <Grid item sm={3}>
                  <InputTextMaster
                    name="exired_date"
                    label="EXP"
                    id="exired_date"
                    value={formBarang.exired_date}
                    onChange={handleChange("exired_date")}
                    placeholder="Expired Date"
                    type={"date"}
                  />
                </Grid> */}
                {/* 
                <Grid item sm={12}>
                  <InputTextMaster
                    name="hargaqjbhpp"
                    label="HARGA QJB / HPP"
                    id="hargaqjbhpp"
                    value={formatNumber(formBarang.hargaqjbhpp)}
                    disabled={true}
                    readOnly={true}
                    placeholder="0"
                  />
                </Grid> */}

                <Grid item sm={12}>
                  <InputTextMaster
                    name="sub_total"
                    label="SUB JUMLAH"
                    id="sub_total"
                    value={formatNumber(
                      (convertToValidPrice(formBarang.harga2) * convertToValidPrice(formBarang.qty)) -
                        convertToValidPrice(formBarang.nilai_disc)
                    )}
                    disabled={true}
                    readOnly={true}
                    placeholder="0"
                    withButtonLeft={true}
                  >
                    <button
                      type={"button"}
                      onClick={null}
                      style={{
                        borderLeft: "1px solid #EAEAEA",
                        borderTop: "1px solid #EAEAEA",
                        borderBottom: "1px solid #EAEAEA",
                        borderRight: "0",
                        background: "#f7f7f7",
                        padding: "0 0 0 0.8rem",
                        cursor: "pointer",
                        borderRadius: "6px 0 0 6px",
                        fontSize: "10px",
                      }}
                    >
                      Rp.
                    </button>
                  </InputTextMaster>
                </Grid>
              </Grid>
            </div>
          </div>

          <div>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <MasterButton
                className={"mt-1"}
                type="submit"
                color={disabled.color}
                name={disabled.label}
                disabled={disabled.disabled}
                size="md"
              />
            </Grid>
          </div>
        </form>
      )}
    </Modal>
  );
};
